export default "__VITE_ASSET__BZtYhUtM__"